<template>
  <!--管控端 manager,admin -->
  <div class="m_container" :class="openType != 'mob' ? 'flex_center flex_items vh100' : ''">
  	<div id="m-page" :class="openType != 'mob' ? 'container_w_h' : 'vh100'">
  	  <div class="m-content page_bg" :style="'height:' + contentH + 'px'">
  	    <PAGE1 v-if="show == 0"></PAGE1>
  	    <PAGE2 v-if="show == 1"></PAGE2>
  	  </div>
  	  <TAB id="m-tab" @tabH="tabHfn" :active1="active1" @change="handleChange"></TAB>
  	</div>
  </div>
</template>
<script>
import TAB from "./manage/managerTab.vue";
import PAGE1 from "./manage/page1.vue";
import PAGE2 from "./manage/page2.vue";
import {openType} from '@/utils/tool.js'
export default {
  components: { TAB, PAGE1, PAGE2 },
  data() {
    return {
      show: 1,
      tabH: 60,
      contentH: this.$JQ(window).height() - 60,
			openType:openType(),
			active1:''
    };
  },
  created() {
    document.title = "项目";
		if(localStorage.getItem('mClickTab')){
			this.active1 = localStorage.getItem('mClickTab')
			this.show = localStorage.getItem('mClickTab') == 'home' ? 0 : 1
		}else{
			this.show = 0
		}
  },
  methods: {
    handleChange(e) {
			localStorage.setItem('mClickTab',e == 0 ? 'home' : 'mine');
			this.active1 = e == 0 ? 'home' : 'mine';
      document.title = e == 0 ? "项目" : "系统";
      this.show = e;
    },
    tabHfn(e) {
      let p = this.openType == 'mob' ? this.$JQ(window).height() : 700;
      this.contentH = p;
    },
  },
};
</script>
<style scoped>

#m-page{
  overflow: hidden;
}
.m-content {
  overflow-y: auto;
}
.m_container.vh100{
	height: 100vh;
}
</style>
